import React, { Component } from 'react';
import { Provider } from 'react-redux';
import configureStore from './Store';
import App from './Containers/App'


const store = configureStore();

class Root extends Component {
  render() {
    return (
      <Provider store={store}>
        <App/>
      </Provider>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./src/Root.js